import { readFileSync, existsSync } from 'fs';
import type { FrameworkIntegration, DetectionResult, IntegrationConfig } from './types.js';

interface PackageJson {
  dependencies?: Record<string, string>;
  devDependencies?: Record<string, string>;
}

export const langgraphIntegration: FrameworkIntegration = {
  name: 'langgraph',
  description: 'LangGraph agent workflow framework',

  detect(): Promise<DetectionResult> {
    let hasLanggraph = false;

    if (existsSync('package.json')) {
      try {
        const pkg = JSON.parse(readFileSync('package.json', 'utf-8')) as PackageJson;
        const deps: Record<string, string> = { ...pkg.dependencies, ...pkg.devDependencies };
        hasLanggraph = '@langchain/langgraph' in deps;
      } catch {
        // Ignore
      }
    }

    return Promise.resolve({
      detected: hasLanggraph,
      confidence: hasLanggraph ? 0.95 : 0,
      files: hasLanggraph ? ['package.json'] : [],
    });
  },

  generate(config: IntegrationConfig): Promise<string> {
    return Promise.resolve(`---
name: mutagent-langgraph-integration
description: Integrate MutagenT with LangGraph for agent workflow observability
framework: langgraph
version: 2.0.0
---

# MutagenT + LangGraph Integration

## Prerequisites Verification

- MUTAGENT_API_KEY: ${config.apiKey.slice(0, 8)}...${config.apiKey.slice(-4)}
- MUTAGENT_ENDPOINT: ${config.endpoint}
- API Connection: Verified

## Installation

\`\`\`bash
bun add @mutagent/langgraph @mutagent/sdk
# or
npm install @mutagent/langgraph @mutagent/sdk
\`\`\`

## Integration

\`\`\`typescript
import { MutagentCallbackHandler } from '@mutagent/langgraph';
import { initTracing } from '@mutagent/sdk/tracing';

// Initialize MutagenT tracing
initTracing({ apiKey: process.env.MUTAGENT_API_KEY! });

// Create callback handler (no constructor args)
const handler = new MutagentCallbackHandler();

// Pass as callback to your LangGraph execution
const result = await graph.invoke(input, {
  callbacks: [handler],
});
\`\`\`

## Streaming

\`\`\`typescript
const handler = new MutagentCallbackHandler();

for await (const event of graph.stream(
  { input: 'Hello' },
  { callbacks: [handler] },
)) {
  console.log(event);
}
\`\`\`

## Verification

\`\`\`bash
mutagent integrate langgraph --verify
\`\`\`

## Documentation

- Full guide: https://docs.mutagent.io/integrations/langgraph
- API Reference: https://docs.mutagent.io/sdk/tracing
- Dashboard: https://app.mutagent.io
`);
  },
};
